import { ContentItem } from '@deltek/specification-client/core/Models/contentItem'
import { DocumentTemplateViewItem } from '@deltek/specification-client/core/Models/documentTemplate'
import {
    GetNuggetResponse,
    GetProductFamilyResponse,
    GetProjectNuggetResponse,
    GetProjectProductFamilyResponse,
} from 'api/graphQL/types/projectElement.types'
import {
    GetOMProjectElementNodesResponseForWorkspace,
    GetProjectElementNodesResponse,
} from 'models/projectElementNode'
import React from 'react'

export interface WorkspaceContentValue {
    updateFamilyArticleData?: (
        newData:
            | Partial<GetProductFamilyResponse>
            | Partial<GetProjectProductFamilyResponse>,
        selected?: boolean,
        overwrite?: boolean,
        isItemRemoved?: boolean
    ) => void
    updateProductArticleData?: (
        newData: GetNuggetResponse | GetProjectNuggetResponse,
        selected?: boolean,
        overwrite?: boolean,
        isItemRemoved?: boolean
    ) => void
    handleRetrieveUpdatedDTV: (tab?: string) => void
    updateCategoryElementState: (
        data:
            | GetProjectElementNodesResponse
            | GetOMProjectElementNodesResponseForWorkspace,
        forceReset?: boolean
    ) => void
    contentItemWorker: ContentItemWorker
    handleRetrieveUpdatedDtvPerPartType: (tab?: string) => void
    fetchSelectedProductFamilyWithTable?: () => void
    refetchSelectedProductsCount?: () => void
}

/** `WorkerMessage` defines the structure of a worker message. */
type ContentItemWorkerMessage = {
    dtv?: Partial<DocumentTemplateViewItem>[]
    selectedTab?: string
    workspaceContentItems: Partial<ContentItem>[]
}
/** `ContentItemWorker` extends `Worker` type class with custom message handling.
 * Primarily used to guard rail the use of "Worker" type (contentItemWorker.js)
 * It has two additional methods: `postMessage` and `onmessage`.
 */
export type ContentItemWorker = {
    // override func signature types
    postMessage: (message: ContentItemWorkerMessage) => void
    onmessage: (event: MessageEvent<ContentItem[]>) => void
    terminate: () => void
}

export const WorkspaceContentContext = React.createContext(
    {} as WorkspaceContentValue
)

export interface WorkspaceContentProviderProps {
    updateFamilyArticleData?: (
        newData:
            | Partial<GetProductFamilyResponse>
            | Partial<GetProjectProductFamilyResponse>,
        selected?: boolean,
        overwrite?: boolean,
        isItemRemoved?: boolean
    ) => void
    updateProductArticleData?: (
        newData: GetNuggetResponse | GetProjectNuggetResponse,
        selected?: boolean,
        overwrite?: boolean,
        isItemRemoved?: boolean
    ) => void
    handleRetrieveUpdatedDTV: (tab?: string) => void
    updateCategoryElementState: (
        data:
            | GetProjectElementNodesResponse
            | GetOMProjectElementNodesResponseForWorkspace,
        forceReset?: boolean
    ) => void
    contentItemWorker: ContentItemWorker
    handleRetrieveUpdatedDtvPerPartType: (tab?: string) => void
    fetchSelectedProductFamilyWithTable?: () => void
    refetchSelectedProductsCount?: () => void
}

export const WorkspaceContentProvider: React.FC<WorkspaceContentProviderProps> = ({
    updateFamilyArticleData,
    updateProductArticleData,
    handleRetrieveUpdatedDTV,
    contentItemWorker,
    updateCategoryElementState,
    children,
    handleRetrieveUpdatedDtvPerPartType,
    fetchSelectedProductFamilyWithTable,
    refetchSelectedProductsCount,
}) => {
    return (
        <WorkspaceContentContext.Provider
            value={{
                updateFamilyArticleData,
                updateProductArticleData,
                handleRetrieveUpdatedDTV,
                contentItemWorker,
                updateCategoryElementState,
                handleRetrieveUpdatedDtvPerPartType,
                fetchSelectedProductFamilyWithTable,
                refetchSelectedProductsCount,
            }}
        >
            {children}
        </WorkspaceContentContext.Provider>
    )
}
